import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import type { PopularRequest } from 'modules/marketing-pages/service';
import VerticalPopularRequestItem from './VerticalPopularRequestItem';

import styles from './VerticalPopularRequest.module.scss';

interface Props {
  isReviewsQAEnabled: boolean;
  popularRequests: Array<PopularRequest>;
}

const VerticalPopularRequest: FC<Props> = ({ popularRequests, isReviewsQAEnabled }) => {
  const { t } = useTranslation('marketingPages');

  if (popularRequests.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('popularRequestSectionTitle')}</h2>
      <div className={styles.cards}>
        {popularRequests.map((popularRequest) => (
          <article className={styles['card-container']} key={popularRequest.id.toString()}>
            <VerticalPopularRequestItem
              popularRequest={popularRequest}
              isReviewsQAEnabled={isReviewsQAEnabled}
            />
          </article>
        ))}
      </div>
    </div>
  );
};

export default VerticalPopularRequest;
